import {
  adminCreate,
  adminDelete,
  adminGet,
  adminList,
  adminUpdate,
  getAdminListQueryKey,
  useAdminCreate,
  useAdminDelete,
  useAdminGet,
  useAdminGetSuspense,
  useAdminList,
  useAdminListSuspense,
  useAdminUpdate,
} from "@/api/generated/endpoints/api"
import { adminCreateBody, adminUpdateBody } from "@/api/generated/schemas/api.zod"

// API hooks and functions
export const adminApi = {
  // Query hooks
  useAdminList,
  useAdminListSuspense,
  useAdminGet,
  useAdminGetSuspense,

  // Mutation hooks
  useAdminCreate,
  useAdminUpdate,
  useAdminDelete,

  // Direct API functions
  adminCreate,
  adminGet,
  adminList,
  adminUpdate,
  adminDelete,

  // Query keys
  getAdminListQueryKey,
}

export const adminSchemas = {
  adminCreateBody,
  adminUpdateBody,
}

export * as AdminModels from "./models"
